import { render, staticRenderFns } from "./disposition-status-creator.vue?vue&type=template&id=34251940"
import script from "./disposition-status-creator.vue?vue&type=script&lang=js"
export * from "./disposition-status-creator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports